export const InitialFormValues = {
  title: '',
  description: '',
  teamId: '',
  userId: '',
  teams: [],
  createLinkedItem: false,
};
